var _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTransferRouteMiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57084 2.20718L6.15662 0.792969L4.74241 2.20718L1.91398 5.03561L0.499768 6.44982L1.91398 7.86404L4.15664 10.1067L4.15664 7.27827L3.3282 6.44982L6.15662 3.6214L8.98505 6.44982L8.15664 7.27823L8.15664 10.1067L10.3993 7.86404L11.8135 6.44982L10.3993 5.03561L7.57084 2.20718ZM8.15664 13.793L8.15664 16.6214L8.98505 17.4498L6.15662 20.2782L3.32819 17.4498L4.15664 16.6214L4.15664 13.7929L1.91398 16.0356L0.499768 17.4498L1.91398 18.864L4.74241 21.6925L6.15662 23.1067L7.57084 21.6925L10.3993 18.864L11.8135 17.4498L10.3993 16.0356L8.15664 13.793Z",
    fill: "#9747FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1259_1077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.10645 6.79297L6.15668 16.7427",
    stroke: "#9747FF",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1259_1077",
    x: 1.10645,
    y: 2.78796,
    width: 10.0503,
    height: 17.9598,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1259_1077"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1259_1077",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferRouteMiddle);
export default __webpack_public_path__ + "static/media/transfer_route_middle.1142d94a6e3eb5115ca346bd09fd97f5.svg";
export { ForwardRef as ReactComponent };